module.exports = __webpack_public_path__ + "global_reach@2x.jpg";